import { useState } from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { Palette, Type, Plus, Minus, X } from "lucide-react";

const THEME_LABELS = {
  pastel: "Pastel & Soft",
  neon: "Neon Glass",
  swiss: "Swiss Blueprint",
};

const FONT_OPTIONS = [
  { id: "small", label: "S" },
  { id: "normal", label: "M" },
  { id: "large", label: "L" },
  { id: "xlarge", label: "XL" },
];

export default function ThemeFontController() {
  const { theme, setTheme, fontScale, setFontScale, themes } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="theme-controller">
      {open && (
        <div
          className="bd-surface p-4 w-72 flex flex-col gap-4"
          style={{ boxShadow: "0 20px 60px -12px rgba(0,0,0,0.25)" }}
          data-testid="theme-controller-panel"
        >
          <div className="flex items-center justify-between">
            <span className="bd-label" style={{ margin: 0 }}>Theme</span>
            <button
              className="bd-btn-ghost bd-btn"
              style={{ padding: "0.25rem 0.5rem" }}
              onClick={() => setOpen(false)}
              data-testid="theme-controller-close"
              aria-label="Close"
            >
              <X size={14} />
            </button>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {themes.map((t) => (
              <button
                key={t}
                onClick={() => setTheme(t)}
                className="bd-btn"
                style={{
                  padding: "0.5rem",
                  fontSize: "0.7rem",
                  background: theme === t ? "var(--primary)" : "var(--bg-soft)",
                  color: theme === t ? "var(--primary-fg)" : "var(--text)",
                }}
                data-testid={`theme-btn-${t}`}
              >
                {THEME_LABELS[t]}
              </button>
            ))}
          </div>

          <div className="bd-divider" />

          <div>
            <span className="bd-label">Text Size</span>
            <div className="grid grid-cols-4 gap-2">
              {FONT_OPTIONS.map((f) => (
                <button
                  key={f.id}
                  onClick={() => setFontScale(f.id)}
                  className="bd-btn"
                  style={{
                    padding: "0.5rem",
                    fontSize: "0.85rem",
                    background: fontScale === f.id ? "var(--secondary)" : "var(--bg-soft)",
                    color: fontScale === f.id ? "var(--secondary-fg)" : "var(--text)",
                  }}
                  data-testid={`font-size-${f.id}`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        className="bd-btn"
        style={{
          padding: "0.75rem 1rem",
          borderRadius: 9999,
          background: "var(--text)",
          color: "var(--bg)",
          border: "2px solid var(--bg)",
          boxShadow: "0 10px 30px -8px rgba(0,0,0,0.45), 0 0 0 2px var(--text)",
          fontWeight: 600,
        }}
        data-testid="theme-controller-toggle"
        aria-label="Open theme and accessibility"
      >
        <Palette size={16} />
        <span className="hidden sm:inline">Theme</span>
      </button>
    </div>
  );
}
